// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tscb","newExpiryDate":"styles_newExpiryDate__29Eju","footer":"styles_footer__HhGjX"};